import { motion, useReducedMotion } from "framer-motion";

// Calm, accessible shared motion presets. Avoid replaying animations on polling updates.
export const staggerContainer = {
  hidden: {},
  show: { transition: { staggerChildren: 0.065, delayChildren: 0.035 } },
};
export const fadeUpItem = {
  hidden: { opacity: 0, y: 10 },
  show: { opacity: 1, y: 0, transition: { duration: 0.48, ease: [0.22, 1, 0.36, 1] } },
};
export const MotionDiv = motion.div;
export function ScrollReveal({ children, className, ...props }) {
  const reduceMotion = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduceMotion ? false : { opacity: 0, y: 12 }}
      animate={reduceMotion ? { opacity: 1, y: 0 } : undefined}
      whileInView={reduceMotion ? undefined : { opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.08 }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      {...props}
    >{children}</motion.div>
  );
}
